/**
 * StatusBadge — inline pill shown next to a step title.
 *
 * current   → "In Progress" in forest colour
 * completed → "Done" in muted
 * upcoming  → renders nothing
 */
import type { StepStatus } from '../constants';
import { PALETTE_FOREST } from '../tokens';

interface StatusBadgeProps {
  status: StepStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  if (status === 'current') {
    return (
      <span
        className="text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded"
        style={{ backgroundColor: `${PALETTE_FOREST}15`, color: PALETTE_FOREST }}
      >
        In Progress
      </span>
    );
  }

  if (status === 'completed') {
    return (
      <span className="text-[9px] font-semibold uppercase tracking-widest text-muted-foreground">
        Done
      </span>
    );
  }

  return null;
}
